import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/sections/home/Home.vue'),
	},
	{
		path: '/info',
		name: 'info',
		component: () => import('@/sections/info/Info.vue'),
	},
	{
		path: '/contacts',
		name: 'contacts',
		component: () => import('@/sections/contacts/Contacts.vue'),
	},
	{
		path: '/associate',
		name: 'associate',
		component: () => import('@/sections/associate/Associate.vue'),
	},
	{
		path: '/about-us',
		name: 'aboutUs',
		component: () => import('@/sections/aboutUs/AboutUs.vue'),
	},
];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
	scrollBehavior() {
		// always scroll to top
		return { top: 0 };
	},
});

export default router;
